import { createAsyncThunk, createEntityAdapter, createSlice } from "@reduxjs/toolkit";

import { SliceStatus } from "../utils";
import { Topic } from "../../typings/Topic";
import api from "./topicsApi";

export const topicsAdapter = createEntityAdapter<Topic>();

const initialState = topicsAdapter.getInitialState<{
  status: SliceStatus;
}>({
  status: SliceStatus.IDLE,
});

export const getTopics = createAsyncThunk<Topic[], void>(
  "topics/getTopics",
  async () => {
    const data = await api.getTopics();
    return data;
  }
);

export const topicsSlice = createSlice({
  name: "topics",
  initialState,

  reducers: {},

  extraReducers: (builder) => {
    builder.addCase(getTopics.pending, (state) => {
      state.status = SliceStatus.LOADING;
    });

    builder.addCase(getTopics.fulfilled, (state, { payload }) => {
      topicsAdapter.upsertMany(state, payload);
      state.status = SliceStatus.IDLE;
    });

    builder.addCase(getTopics.rejected, (state) => {
      state.status = SliceStatus.FAILED;
    });
  },
});

export default topicsSlice.reducer;
